import { render, staticRenderFns } from "./TeamEdit.vue?vue&type=template&id=368646fd&scoped=true"
import script from "./TeamEdit.vue?vue&type=script&lang=js"
export * from "./TeamEdit.vue?vue&type=script&lang=js"
import style0 from "./TeamEdit.vue?vue&type=style&index=0&id=368646fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368646fd",
  null
  
)

export default component.exports